module.exports = __webpack_public_path__ + "img/184.product_inventory.5c7d9205.svg";